import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'
import EmailEvent from "./emailevent.component.jsx";

class EmailDeliveredEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            modal: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            quote: nextProps.quote || null,
            proposal: nextProps.proposal || null,
        })
    }

    render() {
        return <EmailEvent
            object={this.state.object}
            proposal={this.state.proposal}
            quote={this.state.quote}
            text={<FormattedMessage
                id="quote.analytics.events.email_delivered.text"
                defaultMessage="Your email has been delivered"
            />}
            icon={'envelope'}
        />
    }

}

export default EmailDeliveredEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/email-delivered.component.jsx